import React from 'react';
import PropTypes from 'prop-types';
import { filestack, filestackDefaultOptions, MAX_FILE_SIZE } from '../../utilities/filestack-package';

function FilestackComponent({
  options,
  customRender: CustomRender,
  onSuccess,
  onError,
}) {
  const extendedOptions = {
    ...options,
    maxSize: MAX_FILE_SIZE,
    onUploadDone: onSuccess,
  };

  return (
    CustomRender
      ? <CustomRender onPick={() => filestack.picker(extendedOptions).open().catch(onError)} />
      : <button onClick={() => filestack.picker(extendedOptions).open().catch(onError)}>Pick file</button>
  );
}

FilestackComponent.propTypes = {
  options: PropTypes.objectOf(PropTypes.any),
  onSuccess: PropTypes.func,
  onError: PropTypes.func,
  customRender: PropTypes.func,
};

FilestackComponent.defaultProps = {
  options: filestackDefaultOptions,
  onSuccess: res => console.info(res),
  onError: err => console.error(err),
  customRender: null,
};

export default FilestackComponent;
